import { createSlice } from '@reduxjs/toolkit';

const trainerAvailabilitySlice = createSlice({
  name: 'trainerAvailability',
  initialState: {
    currentDate: null,
    worksTrainers: [],
  },
  reducers: {
    // Полная замена тренеров на конкретную дату
    setTrainersForCurrentSlot(state, action) {
      const { date, trainers } = action.payload;
      state.currentDate = date;
      state.worksTrainers = trainers || [];
    },

    // Полная замена списка тренеров
    addTrainerForCurrentSlot(state, action) {
      const { date, trainer } = action.payload;
      state.currentDate = date;
      state.worksTrainers = trainer ? [...trainer] : [];
    },

    // Обновление конкретного тренера по trainerID
    updateTrainerById(state, action) {
      const { trainerID, updatedTrainer } = action.payload;

      console.log(updatedTrainer);

      const index = state.worksTrainers.findIndex(
        (t) => t.trainerID === trainerID
      );

      if (index !== -1) {
        state.worksTrainers[index] = {
          ...updatedTrainer,
        };
      }
    },

    // Очистка данных
    clearTrainersForCurrentSlot(state) {
      state.currentDate = null;
      state.worksTrainers = [];
    },
  },
});

export const {
  setTrainersForCurrentSlot,
  addTrainerForCurrentSlot,
  updateTrainerById,
  clearTrainersForCurrentSlot,
} = trainerAvailabilitySlice.actions;

// Селекторы
export const selectTrainersForCurrentSlot = (state) =>
  state.trainerAvailability.worksTrainers;

export const selectTrainerCurrentDate = (state) =>
  state.trainerAvailability.currentDate;

export default trainerAvailabilitySlice.reducer;
